import React, { useEffect, useState } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { Controller, useForm } from 'react-hook-form'
import SwalCustom from '../../alert/swal-custom'
import {
  deleteContractSettingAPI,
  putContractSettingAPI
} from '../../services/setting-contracts'
import Error_false from '../error/error-false'
import ModalCustom from '../modal-custom'
import { Button, Col, Form, Row } from 'react-bootstrap'
import LabelCustom from '../label-custom'
import { Select } from 'antd'
import { TXTSUCCESS } from '../../Constants'
import InputIDCardNumber from '../input-idcard-num'

const schema = yup
  .object({
    idCard: yup.string().required('Please, Input ID Card')
  })
  .required()
export default function EditContracts({
  setIsSave,
  showCreate,
  isSave,
  setShowCreate,
  detail,
  orgId,
  setIsRefresh,
  handleKeyDownNum
}) {
  const {
    control,
    setValue,
    setError,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  useEffect(() => {
    setValue('idCard', detail.id_card ?? '')
    setError('idCard', false)

    setValue('status', detail.status ?? '')
    setError('status', false)
  }, [detail.id_card, detail.insert_date, setError, setValue])

  const onSubmit = (data) => {
    const body = {
      id: detail.id ?? '',
      orgId: orgId,
      logInStatusId:
        data.status === 'Active'
          ? 1
          : data.status === 'Inactive'
            ? 2
            : data.status,
      idCard: data.idCard.replace(/\s/g, '') ?? ''
    }
    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to confirm?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        putHoliday(body)
        handleClose()
      }
    })
  }

  const putHoliday = async (body) => {
    const data = await putContractSettingAPI(body)
    setIsSave(false)
    if (!data) return
    if (data.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        setIsRefresh(true)
      })
    } else {
      Error_false(data)
    }
  }

  const fnReset = () => {
    setError('idCard', false)
    // setError("date", false);
  }

  const handleClose = () => {
    setShowCreate(false)
    fnReset()
  }

  const onCancel = () => {
    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to cancel?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: 'var(--comp-badge-color-background-primary)',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, cancel it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        cancelHoliday()
        handleClose()
      }
    })
  }

  const cancelHoliday = async () => {
    const id = detail.id ?? ''
    const data = await deleteContractSettingAPI({ id })
    setIsSave(false)
    if (!data) return
    if (data.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        setIsRefresh(true)
        // setIsRefresh(false);
      })
    } else {
      Error_false(data)
    }
  }

  return (
    <ModalCustom width={500} open={showCreate} onCancel={handleClose}>
      <label>Update Contract</label>

      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-3 row"
        style={{ rowGap: '13px' }}
      >
        <Row style={{ rowGap: '15px' }}>
          <Col md={12}>
            <LabelCustom text={'ID Card'} />
            <Controller
              name={'idCard'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <InputIDCardNumber value={value} onChange={onChange} />

                // <Form.Control
                //   maxLength={13}
                //   value={value}
                //   onChange={onChange}
                //   onKeyDown={handleKeyDownNum}
                // />
              )}
            />
            {errors.type?.message && (
              <label className="small text-danger">{errors.type.message}</label>
            )}
          </Col>

          <Col md={12}>
            <LabelCustom text={'Status'} />
            <Controller
              name={'status'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Select
                  value={value}
                  onChange={onChange}
                  isClearable={true}
                  options={[
                    {
                      value: 1,
                      label: 'Active'
                    },
                    {
                      value: 2,
                      label: 'Inactive'
                    }
                  ]}
                  className="w-100"
                />
              )}
            />
            {errors.type?.message && (
              <label className="small text-danger">
                {errors.status.message}
              </label>
            )}
          </Col>

          <Col xl={12} className="text-center mt-4">
            <Button
              className="px-4 me-2 text-white"
              variant="secondary"
              type="button"
              onClick={handleClose}
            >
              {/* Close */}
              Cancel
            </Button>
            <Button type="submit" className="px-4" disabled={isSave}>
              {isSave ? 'Saving...' : 'Save'}
            </Button>
          </Col>
        </Row>
      </Form>
    </ModalCustom>
  )
}
